import store from "./store/index";
import { createI18n } from "vue-i18n";

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context(
    "./assets/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = { ...messages[locale], ...locales(key) };
      // messages[locale] = locales(key).default;
    }
  });
  return messages;
}
function detectBrowserLocale(supported) {
  const languages = navigator.languages || [navigator.language];
  for (const browserTag of languages) {
    if (!browserTag) {
      continue;
    }
    // BCP-47 tag → a supported nyelvi kód (pl. 'hu-HU' → 'hu')
    const match = String(browserTag)
      .toLowerCase()
      .match(/^([a-z]{2,3})([-_]|$)/);
    const candidate = match && match[1];
    if (candidate && supported.includes(candidate)) {
      return candidate;
    }
  }
  return null;
}

const messages = loadLocaleMessages();

let userLanguage = store.state.user?.language_code;
if (!userLanguage) {
  userLanguage =
    localStorage.getItem("language") ||
    detectBrowserLocale(Object.keys(messages)) ||
    process.env.VUE_APP_I18N_LOCALE ||
    "en";
}

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: userLanguage || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages,
});
